// Onay kuyruğu diyalogları (KpiApprovalQueue'dan ayrıldı — güvenlik/UX taraması 2026-10-08, U-M3 +
// 600 satır sınırı): "Açıklama iste" satır içi diyaloğu, toplu onay ÖNCESİ onay penceresi
// ("N girdi onaylanacak" — yalnız "Seçilileri onayla"; tekil ✓ doğrudan) ve toplu onay sonucu.

import type { KpiValueDto } from "../../api/kpi";
import type { QueueItem } from "../../lib/kpi-queue";
import { KPI_COPY } from "../../lib/kpi-ui";
import { ConfirmDialog } from "../common/ConfirmDialog";

export function KpiQueueClarifyDialog(p: {
  item: QueueItem;
  note: string;
  busy: boolean;
  onNote: (v: string) => void;
  onCancel: () => void;
  onSend: () => void;
}): JSX.Element {
  return (
    <div
      role="dialog"
      aria-label="Açıklama iste"
      className="px-3 py-3"
      style={{ borderTop: "1px solid var(--color-border)", background: "var(--color-bg)" }}
    >
      <div className="text-sm mb-2" style={{ color: "var(--color-text)" }}>
        <b>
          {p.item.indicator.label} · {p.item.year}
        </b>{" "}
        için müşteriye görünür not:
      </div>
      <textarea
        aria-label="Açıklama notu"
        value={p.note}
        onChange={(e) => p.onNote(e.target.value)}
        rows={2}
        style={{
          width: "100%",
          padding: 8,
          borderRadius: 8,
          border: "1px solid var(--color-border)",
          fontSize: "0.85rem",
        }}
        placeholder="Örn. 2024'e göre 18 kat artış görünüyor — birimi ve kaynağı doğrular mısınız?"
      />
      <div className="flex justify-end gap-2 mt-2">
        <button
          type="button"
          onClick={p.onCancel}
          className="px-3 py-1.5 rounded-lg text-sm"
          style={{ border: "1px solid var(--color-border)" }}
        >
          Vazgeç
        </button>
        <button
          type="button"
          disabled={p.busy || !p.note.trim()}
          onClick={p.onSend}
          className="px-3 py-1.5 rounded-lg text-sm font-semibold"
          style={{ background: "var(--color-primary)", color: "var(--color-surface)" }}
        >
          Gönder
        </button>
      </div>
    </div>
  );
}

export function KpiQueueBulkDialogs(p: {
  /** onay bekleyen toplu onay — seçili sayı (null = kapalı) */
  confirmCount: number | null;
  busy: boolean;
  onConfirm: () => void;
  onCancelConfirm: () => void;
  result: { verified: number; conflicts: KpiValueDto[] } | null;
  onCloseResult: () => void;
}): JSX.Element {
  return (
    <>
      <ConfirmDialog
        open={p.confirmCount !== null}
        title={KPI_COPY.bulkApprove.title(p.confirmCount ?? 0)}
        body={KPI_COPY.bulkApprove.body}
        confirmLabel={KPI_COPY.bulkApprove.confirm}
        tone="neutral"
        busy={p.busy}
        onConfirm={p.onConfirm}
        onCancel={p.onCancelConfirm}
      />
      <ConfirmDialog
        open={p.result !== null}
        title="Toplu onay sonucu"
        body={
          p.result
            ? `${p.result.verified} onaylandı${p.result.conflicts.length ? ` · ${p.result.conflicts.length} değişti — yeniden bakın` : ""}`
            : ""
        }
        confirmLabel="Tamam"
        tone="neutral"
        onConfirm={p.onCloseResult}
        onCancel={p.onCloseResult}
      />
    </>
  );
}
